<template>
  <div class="certificates">
    <h2>Sertifikalarım</h2>

    <form @submit.prevent="uploadCertificate" class="upload-box">
      <input type="file" @change="handleFile" required />
      <p v-if="selectedFile" class="selected-file">{{ selectedFile.name }}</p>
      <button class="btn primary">Yükle</button>
    </form>

    <p v-if="certificates.length === 0">Henüz yüklenmiş bir sertifikanız yok.</p>

    <ul class="cert-list">
      <li v-for="cert in certificates" :key="cert.id" class="cert-item">
        <a :href="`${baseURL}/uploads/certificates/${cert.file_name}`" target="_blank">
          {{ cert.file_name.split('-').slice(1).join('-') }}
        </a>
        <button class="btn red small" @click="deleteCertificate(cert.id)">🗑</button>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getToken } from '@/utils/auth'

const certificates = ref([])
const selectedFile = ref(null)
const baseURL = process.env.VUE_APP_API_URL

onMounted(fetchCertificates)

function handleFile(event) {
  selectedFile.value = event.target.files[0]
}

async function fetchCertificates() {
  const res = await fetch(`${baseURL}/settings/certificates`, {
    headers: { Authorization: `Bearer ${getToken()}` }
  })

  if (!res.ok) {
    const error = await res.json()
    console.error('Sertifikalar alınamadı:', error)
    return
  }

  const data = await res.json()
  if (Array.isArray(data)) {
    certificates.value = data.sort((a, b) => new Date(b.uploaded_at) - new Date(a.uploaded_at))
  } else {
    console.warn('Gelen veri dizi değil:', data)
  }
}

async function uploadCertificate() {
  if (!selectedFile.value) return alert('Dosya seçiniz.')

  const formData = new FormData()
  formData.append('file', selectedFile.value)

  const res = await fetch(`${baseURL}/settings/certificates`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${getToken()}` },
    body: formData
  })

  const data = await res.json()
  if (res.ok) {
    alert('Sertifika yüklendi.')
    selectedFile.value = null
    fetchCertificates()
  } else {
    alert(data.message || 'Hata oluştu.')
  }
}

async function deleteCertificate(id) {
  if (!confirm('Silmek istediğinize emin misiniz?')) return

  const res = await fetch(`${baseURL}/settings/certificates/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${getToken()}` }
  })

  const data = await res.json()
  if (res.ok) {
    alert(data.message)
    fetchCertificates()
  } else {
    alert(data.message || 'Silinemedi.')
  }
}
</script>

<style scoped>
.certificates {
  max-width: 700px;
  margin: auto;
  padding: 20px;
}

.upload-box {
  display: flex;
  flex-direction: row;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.upload-box input[type="file"] {
  flex: 1;
  min-width: 200px;
}

.selected-file {
  font-size: 14px;
  color: #555;
  margin-top: -5px;
  margin-bottom: 5px;
  width: 100%;
}

.cert-list {
  list-style: none;
  padding: 0;
}

.cert-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f5f5f5;
  border-radius: 6px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}

.cert-item a {
  color: #0c2d57;
  text-decoration: none;
  word-break: break-all;
  flex: 1;
}

.btn.primary {
  background: #0c2d57;
  color: white;
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.btn.red.small {
  background: #e74c3c;
  padding: 4px 8px;
  border: none;
  color: white;
  border-radius: 4px;
  font-size: 0.85em;
  cursor: pointer;
  margin-left: 10px;
}

/* === Responsive === */
@media (max-width: 600px) {
  .upload-box {
    flex-direction: column;
    gap: 12px;
  }

  .cert-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .btn.red.small {
    align-self: flex-end;
    margin-left: 0;
  }
}
</style>
